import axios from "axios";

const requester = axios.create({
  baseURL: "http://localhost:9000/jobs",
});

export default requester;
